import React from 'react'
import styled from 'styled-components'
import imageWave from '../images/wave.png'

const Wrapper = styled.div`
  img {
    width: 100%;
    max-height: 100px;
    background: #b4e4f9;
  }
`

const Wave = () => {
  return (
    <Wrapper>
      <img src={imageWave} />
    </Wrapper>
  )
}
export default Wave
